import React from 'react';

import Card from './Card';
import { formatNumber } from '../../utils/number';
import aashayCommits from '../../data/aashay-commits';

import './AashayCommitsEntry.css';

export default ({ description }) => (
  <div className="AashayCommitsEntry">
    <p className="AashayCommitsEntry__description">
      {description}
    </p>
    <Card disablePadding>
      <table className="AashayCommitsEntry__commits">
        <tbody>
          {aashayCommits.map(commit => (
            <tr key={commit.fakeSha} className="AashayCommitsEntry__commit">
              <td className="AashayCommitsEntry__commit-cell AashayCommitsEntry__commit-cell--avatar"/>
              <td className="AashayCommitsEntry__commit-cell AashayCommitsEntry__commit-cell--message">
                {commit.message}
              </td>
              <td className="AashayCommitsEntry__commit-cell AashayCommitsEntry__commit-cell--counts">
                <span className="AashayCommitsEntry__count AashayCommitsEntry__count--addition">
                  +{formatNumber(commit.stats.additions)}
                </span>
                <span className="AashayCommitsEntry__count AashayCommitsEntry__count--deletions">
                  -{formatNumber(commit.stats.deletions)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/timeline/AashayCommitsEntry.js